import { getAddress } from '@ethersproject/address';
import invariant from 'tiny-invariant';
import warning from 'tiny-warning';

/**
 * Warns if addresses are not checksummed
 * @param address
 */
export function validateAndParseAddress(address: string): string {
  try {
    const checksummedAddress = getAddress(address);
    warning(address === checksummedAddress, `${address} is not checksummed.`);
    return checksummedAddress;
  } catch (error) {
    invariant(false, `${address} is not a valid address.`);
  }
}
